import React from 'react';
import { Form, Input } from 'antd';
import { TextInputProps } from './textfield';

export function EmailInput(props: TextInputProps) {
  const handleChange = (value: string) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <>
      <Form.Item
        name={props.name}
        label={props.label}
        rules={[
          { type: 'email', message: `${props.label} is not a valid email` },
          { required: props.required, message: `${props.label} is required` },
        ]}
        tooltip={props.tooltip}
        extra={props.extra}
      >
        <Input
          type="email"
          value={props.value}
          maxLength={255}
          onChange={(event) => {
            handleChange(event.target.value);
          }}
          disabled={props.disabled}
        />
      </Form.Item>
    </>
  );
}
